const actions = {
    GET_DRIVERS: "drivers/GET_DRIVERS",
    SET_DRIVERS: "drivers/SET_DRIVERS",

    GET_DRIVER: "drivers/GET_DRIVER",
    SET_DRIVER: "drivers/SET_DRIVER",

    SET_INITIAL: "drivers/SET_INITIAL"
};

export default actions